var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsCameraOffFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lnicnyd25a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1368 0v1600H0V0h1368z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qmf7lzrpzb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.301.56.251.221L57.35 53.578a2.667 2.667 0 0 1-3.52 3.993l-.252-.221-11.007-11.008a5.335 5.335 0 0 1-5.238 4.325h-32A5.333 5.333 0 0 1 0 45.333v-32c0-2.6 1.862-4.767 4.325-5.238L.781 4.552A2.667 2.667 0 0 1 4.301.56zM37.333 8a5.333 5.333 0 0 1 5.334 5.333v8l13.927-9.284a1.333 1.333 0 0 1 2.073 1.109v32.35c0 .195-.042.379-.116.545L20.497 8h16.836z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lnicnyd25a)",
    transform: "translate(-352 -336)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qmf7lzrpzb)",
    transform: "translate(354.667 338.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h58.667v58.13H0V0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCameraOffFilled);
export default __webpack_public_path__ + "static/media/icons-camera-off-filled.b026626c64ccb6c8b0daaf119fa06fc7.svg";
export { ForwardRef as ReactComponent };